export default {
  title: 'Acquista gift card digitali',
  subtitle:
    'Dillo con una gift card di {{companyName}}. Perfetta per compleanni, per un grazie o semplicemente perché – utilizzabile liberamente per cibo e bevande.',
  header: {
    title: 'Gift Card',
    subtitle: 'Regala gioia',
  },
  buttons: {
    buy_now: 'Acquista ora',
  },
};
